/** Pure room simulation used by the simulated provider (see simulatedProvider.ts). */
import type { MediaSnapshot, SubscriptionPlan } from './contract';

/** Rotates the active speaker; returns null when nobody can speak. */
export function speakerPatch(snapshot: MediaSnapshot): Partial<MediaSnapshot> | null {
  const candidates = snapshot.participants.filter((p) => p.micOn && !p.isLocal);
  const pick = candidates[Math.floor(Math.random() * candidates.length)];
  if (!pick) return null;

  const ordered = [pick.id, ...candidates.filter((p) => p.id !== pick.id).map((p) => p.id)];
  return {
    activeSpeakerIds: ordered.slice(0, 3),
    participants: snapshot.participants.map((p) => ({
      ...p,
      speaking: p.id === pick.id,
      audioLevel: p.id === pick.id ? 0.45 + Math.random() * 0.5 : 0,
    })),
  };
}

/** Downlink and loss derived from what is actually subscribed. */
export function statsPatch(plan: SubscriptionPlan): Partial<MediaSnapshot> {
  const loss = Math.max(0, Math.random() * 0.02 - 0.005);
  return {
    packetLoss: Number(loss.toFixed(4)),
    quality: loss > 0.05 ? 'poor' : 'excellent',
    downlinkBps: plan.video.size * 550_000 + plan.audio.length * 55_000,
  };
}
